import { createMuiTheme } from '@material-ui/core/styles';
import palette from './palette';

const theme = createMuiTheme({
    palette,
    typography: {
        fontFamily: 'Sukhumvit Set',
        fontSize: 22.4
    }
});

export default theme;
